jQuery($ => {
    class FaqsFeed {
      constructor(element) {
        this._        = element;
        this._element = $(element);
        this._feed    = this._element.find('.o-faqs-feed__results');
        this._form    = this._element.find('.o-faqs-feed__filters-form');
        this._inputs  = this._form.find('input');
        this._categoryInputs = this._form.find('input[name="category[]"]');

        this._searchHero = this._element.siblings('.o-search-hero');
        this._searchHeroForm = this._searchHero.find('.m-search__form');
        this._searchHeroInput = this._searchHeroForm.find('.m-search__input');

        this._useAjax = this._element.hasClass('o-faqs-feed--has-ajax');
        this._ajaxRunning = 0;

        this._originalSelectedCategories = null;
        this._originalSearch = null;
  
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'init', this );

        this._originalSelectedCategories = this._categoryInputs.filter(':checked').map(function() {
          return $(this).val();
        }).get();

        this._originalSearch = this._searchHeroInput.val();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Submit
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleSubmit(form = null) {
        if (!form) {
          form = this._form;
        }

        // Get all fields from form
        let formData = form.serialize();

        formData += '&action=load_filtered_faqs';
        // formData += `&url=${JSON.stringify(window.location.href.replace(window.location.search, ''))}`;

        this._element.addClass('o-faqs-feed--loading');

        // Push current feed html and url to history
        window.history.pushState(
          {
            feed:                this._feed.html(),
            selected_categories: this._originalSelectedCategories,
            current_search:      this._originalSearch
          },
          {},
          window.location.href
        );

        $.ajax({
          type: 'POST',
          url: AJAX.url,
          data: formData,
          beforeSend: () => {
            this._ajaxRunning++;
          },
          success: (result) => {
            if (result.data.feed) {
              this._feed.html(result.data.feed);

              setTimeout(() => {
                this.reinitializeChildren();
              }, 100);
            }

            if (result.data.url) {
              window.history.pushState(
                {
                  feed: result.data.feed,
                  selected_categories: result.data.selected_categories,
                  current_search: result.data.current_search
                },
                {},
                result.data.url
              );
            }

            this.syncFilters(result.data.selected_categories, result.data.current_search);
          },
          error: (error) => {
            console.error(error);
          },
          complete: () => {
            this._ajaxRunning--;
            this._element.removeClass('o-faqs-feed--loading');
          }
        })
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        this._inputs.on('change', () => {
          this._form.submit();
        });

        this._form.on('submit', (e) => {
          if (this._useAjax) {
            e.preventDefault();
            this.handleSubmit();
          }
        });

        this._searchHeroForm.on('submit', (e) => {
          if (this._useAjax) {
            e.preventDefault();
            this.handleSubmit(this._searchHeroForm);
          }
        });

        $(window).on('popstate', (e) => {
          if (e.originalEvent.state !== null) {
            if (e.originalEvent.state.feed) {
              this._feed.html(e.originalEvent.state.feed);
  
              // Make sure accordions are re-initialized
              setTimeout(() => {
                this.reinitializeChildren();
              }, 100);
            }

            this.syncFilters(e.originalEvent.state.selected_categories, e.originalEvent.state.current_search);
          }
        });
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Reinitialize Children
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      reinitializeChildren() {
        this._feed.find('.o-accordion-groups').each(function() {
          $(this).accordion_groups();
        });
        this._feed.find('.m-accordion').each(function() {
          $(this).accordion();
        });
        this._feed.find('.m-filter-tags').each(function() {
          $(this).filter_tags();
        });
      }

      syncFilters(selectedCategories, currentSearch) {
        if (!selectedCategories) selectedCategories = [];
        if (!currentSearch) currentSearch = '';

        this._searchHeroInput.val(currentSearch);
        this._originalSearch = currentSearch;

        this._originalSelectedCategories = selectedCategories;
        this._categoryInputs.each(function() {
          if (selectedCategories.includes($(this).val())) {
            $(this).prop('checked', true);
          } else {
            $(this).prop('checked', false);
          }
        });
      }
    }

  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.faqs_feed = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].faqs_feed = new FaqsFeed(_[i], opt);
        else
          ret = _[i].faqs_feed[opt].apply(_[i].faqs_feed, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.o-faqs-feed').faqs_feed();
});